<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(localSignup)">
        <b-row class="mb-3 d-md-block">
          <b-col>
            <validation-provider v-slot="{ errors }" rules="required|email" name="Email">
              <InputText
                v-model="email"
                :errors="errors.concat(emailRepeatedCheck)"
                :placeholder="$t('profile.signUp.main.email')"
                @blur="startCheckingEmail"
                @change="checkEmail"
              />
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mb-3 d-md-block">
          <b-col>
            <validation-provider v-slot="{ errors }" rules="required|min:1" name="Password">
              <InputText
                v-model="password"
                :errors="errors"
                type="password"
                autocomplete="current-password"
                :placeholder="$t('profile.signUp.main.password')"
              />
            </validation-provider>
          </b-col>
        </b-row>
        <div class="mt-2">
          <recaptcha class="mb-3 row justify-content-center" />
          <Button width="full" color="green" :submit="true">
            {{ $t('profile.signUp.main.title') }}&nbsp;>
          </Button>
        </div>
      </b-form>
    </validation-observer>
    <div v-if="error">
      <div v-if="typeof errorMessage === 'string'">
        <ErrorSection :error-message="errorMessage" />
      </div>
      <div v-else>
        <div v-for="(message, index) in errorMessage" :key="index">
          <ErrorSection :error-message="message" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VeeValidate from '~/plugins/vee-validate.js';
import { mapState } from 'vuex';
import InputText from 'UI/InputText';
import Button from 'UI/Button';
import ErrorSection from '@/components/User/Form/ErrorSection';
export default {
  components: {
    InputText,
    Button,
    ErrorSection
  },
  data() {
    return {
      error: false,
      errorMessage: '',
      checkingEmail: false,
      email: '',
      password: ''
    };
  },
  computed: {
    ...mapState('user', ['isEmailChecking']),
    isEmailOk() {
      return this.$store.getters['user/isEmailAvailable'](this.email);
    },
    emailRepeatedCheck() {
      if (!this.isEmailChecking && !this.isEmailOk && this.checkingEmail) {
        return [this.$t('profile.signUp.main.emailInUse')];
      } else {
        return [];
      }
    },
    emailIsNotRepeated() {
      return !this.isEmailChecking && this.isEmailOk;
    }
  },
  created() {
    VeeValidate(this.$i18n.locale);
  },
  methods: {
    startCheckingEmail() {
      this.checkingEmail = true;
      this.checkEmail();
    },
    checkEmail() {
      if (this.checkingEmail) {
        this.$store.dispatch('user/CHECK_EMAIL_AVAILABILITY', this.email);
      }
    },
    async localSignup() {
      this.$emit('loading', true);
      await this.signUpUser();
      this.$emit('loading', false);
    },
    async signUpUser() {
      if (!this.emailIsNotRepeated) {
        this.error = true;
        this.errorMessage = this.$t('profile.signUp.main.emailNotAvailable');
      } else {
        try {
          const captchaToken = await this.$recaptcha.getResponse();
          const response = await this.$store.dispatch('user/SIGN_UP', {
            email: this.email,
            password: this.password,
            captchaToken
          });
          if (!response.error) {
            this.$emit('signup');
            await this.$store.dispatch('auth/loadUser', {
              token: response.token,
              strategy: 'local'
            });
            this.$emit('login');
            this.$store.dispatch('updateUserDataIntercom');
          } else {
            this.error = true;
            this.errorMessage = [];
            for (let i = 0; i < response.data.length; i++) {
              let res = `${this.$t(`${response.data[i].code}`)} ${
                response.data[i].data ? `: min. ${response.data[i].data}` : ''
              }`;
              this.errorMessage.push(res);
            }
          }

          try {
            await this.$recaptcha.reset();
          } catch (error) {
            console.error('SIGN UP', error);
          }
        } catch (error) {
          this.error = true;
          this.errorMessage = this.$t('profile.signUp.main.error');
          console.error('SIGN UP', error);
        }
      }
    }
  }
};
</script>

<style></style>
